const state = {
	updatesSaved: [],
	updatesSavedTotals: {},
	shards: [],
	hosts: [],
	vendors: []
}

export default state
